export default [
  {
    path: '/explosion-de-insumos-yoc',
    name: 'suppliesExplosionYoc',
    component: () => import('@/views/supplies/SuppliesExplosion.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
]
